var React = require('react');

function ArrowNext (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.6786 15.01L1.32143 1.1005","stroke":"#E3232A","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1.32143 29.4543L18.6786 15.5448","stroke":"#E3232A","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowNext.defaultProps = {"width":"20","height":"31","viewBox":"0 0 20 31","fill":"none"};

module.exports = ArrowNext;

ArrowNext.default = ArrowNext;
